<template>
  <div :style="multipleOptions">
    <div v-for="(option, index) in options" :key="option.label" :id="id" class="wrapper">
      <input
        :id="id + index"
        :name="id"
        type="radio"
        :value="value"
        :checked="option.value === value"
        :disabled="disabled"
        :required="required"
        @change="updateValue(option.value)"
        :style="getStyles"
        class="radio-color"
      />
      {{ option.label }}
      <!-- Can be used to render functionality on a specific option -->
      <slot v-if="option.value === value" :name="option.value" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SRadio',
  model: {
    event: "change",
  },
  data(){
    return{
      id: ''
    }
  },
  props: {
    value: {},
    options: {
      type: Array,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    optionsPerRow: { // number of options to show in one line in case of multiple options
      type: Number,
      default: 4
    },
    direction: { // multiple options should be displayed vertical or horizontal
      type: String,
      default: 'vertical'
    }
  },
  methods: {
    updateValue(value) {
      // console.log('updatedval func: ', value)
      this.$emit("change", value);
    },
  },
  computed: {
    getStyles(){
      if(this.disabled){
        return{
          "cursor": "not-allowed"
        }
      }
      else{
        return ""
      }
    },
    multipleOptions(){
       if(this.direction=='horizontal'){
         return{
           "display": "grid",
           "grid-template-columns": "repeat("+this.optionsPerRow+",1fr)"
         }
       }
       else{
         return ""
       }
    }
  },
  mounted(){
    this.id = this._uid;
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: grid;
  grid-template-columns: 18px auto;
  align-items: center;
  color: var(--black);
  cursor: pointer;
  line-height: 1.5;
  font-size: 14px !important;
  font-family: "Roboto";
  input {
    cursor: pointer;
    accent-color: var(--primary);
    margin: 0 !important;
  }
}
</style>
